const alert = {
  baseStyle: {
    container: {
      padding: '1.5rem',
    },
  },
  variants: {
    subtle: ({ colorScheme }) => ({
      title: {
        color: `${colorScheme}.500`,
      },
      description: {
        color: `${colorScheme}.500`,
      },
    }),
  },
  defaultProps: {
    colorScheme: 'green',
  },
};

export default alert;
